import CombinedStyleSheet from "../internal/CombinedStyleSheet";
import suffixProperties from "../internal/suffixProperties";
import systemDenseWeights from "../helpers/systemDenseWeights";
import human from "./human";

// https://developer.apple.com/videos/play/wwdc2016/801/

const getStylesForColor = color => {
  const colorSuffix = color === "white" ? "White" : "";
  return {
    largeTitle: {
      ...human[`largeTitle${colorSuffix}Object`],
      ...systemDenseWeights.regular,
      lineHeight: '52px'
    },
    title1: {
      ...human[`title1${colorSuffix}Object`],
      ...systemDenseWeights.regular,
      lineHeight: '43px'
    },
    title2: {
      ...human[`title2${colorSuffix}Object`],
      ...systemDenseWeights.regular,
      lineHeight: '35px'
    },
    title3: {
      ...human[`title3${colorSuffix}Object`],
      ...systemDenseWeights.regular,
      lineHeight: '32px'
    },
    headline: {
      ...human[`headline${colorSuffix}Object`],
      ...systemDenseWeights.semibold,
      lineHeight: '28px'
    },
    body: {
      ...human[`body${colorSuffix}Object`],
      ...systemDenseWeights.regular,
      lineHeight: '28px'
    },
    callout: {
      ...human[`callout${colorSuffix}Object`],
      ...systemDenseWeights.regular,
      lineHeight: '26px'
    },
    subhead: {
      ...human[`subhead${colorSuffix}Object`],
      ...systemDenseWeights.regular,
      lineHeight: '25px'
    },
    footnote: {
      ...human[`footnote${colorSuffix}Object`],
      ...systemDenseWeights.regular,
      lineHeight: '23px'
    },
    caption1: {
      ...human[`caption1${colorSuffix}Object`],
      ...systemDenseWeights.regular,
      lineHeight: '20px'
    },
    caption2: {
      ...human[`caption2${colorSuffix}Object`],
      ...systemDenseWeights.regular,
      lineHeight: '16px'
    }
  };
};

export default CombinedStyleSheet.create({
  ...getStylesForColor("black"),
  ...suffixProperties(getStylesForColor("white"), "White")
});